export default class ModalClass {
  #isOpen;

  #modalProps;

  constructor(
    options = {
      modalSelector: ""
    }
  ) {
    this.#isOpen = false;
    this.#modalProps = options;

    this.$$modal
      .on("show.bs.modal", this.openModalCallback.bind(this))
      .on("hidden.bs.modal", this.closeModalCallback.bind(this));
  }

  get modalProps() {
    return this.#modalProps;
  }

  get isOpen() {
    return this.#isOpen;
  }

  set isOpen(value) {
    this.#isOpen = value;
  }

  get $modal() {
    return document.querySelector(this.modalProps.modalSelector);
  }

  get $$modal() {
    return $(this.$modal);
  }

  openModalCallback() {
    this.isOpen = true;

    return this;
  }

  closeModalCallback() {
    this.isOpen = false;

    return this;
  }

  openModal() {
    $(this.$modal).modal("show");

    return this;
  }

  closeModal() {
    $(this.$modal).modal("hide");

    return this;
  }

  toggleModal() {
    return this.isOpen ? this.closeModal() : this.openModal();
  }
}
